<script>
import EmojiGlyph from 'shared/components/emoji/EmojiGlyph.vue';

// Aceleres: `open` emite o proprio elemento da pilula, e nao o retangulo
// dele. Enviar o retangulo congelava a posicao no instante do clique, e o
// card (position:fixed, em coordenadas de viewport) ficava para tras assim
// que a lista rolava ou o layout mexia — uma imagem a acabar de carregar
// bastava. Com o elemento, o card recalcula a ancora quando precisa.
//
// Aceleres: a chip de reacao segue o WhatsApp — UMA pilula por mensagem,
// com os emojis distintos lado a lado e o total de reacoes a direita (o
// numero so aparece a partir de 2). Antes era uma pilula por emoji, o que
// espalhava varios circulos soltos embaixo do balao. O clique nao alterna
// mais a reacao direto: abre o modal de detalhes, igual ao WhatsApp.
export default {
  name: 'MessageReactions',
  components: { EmojiGlyph },
  props: {
    reactions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['open'],
  computed: {
    total() {
      return this.reactions.length;
    },
    // Ordem de chegada, sem repetir emoji. O WhatsApp mostra no maximo 3
    // glifos na pilula, mesmo quando ha mais tipos de reacao.
    visibleEmojis() {
      const distinct = [];
      this.reactions.forEach(reaction => {
        const { emoji } = reaction || {};
        if (emoji && !distinct.includes(emoji)) distinct.push(emoji);
      });
      return distinct.slice(0, 3);
    },
    reactorNames() {
      return this.reactions
        .map(reaction => reaction?.name)
        .filter(Boolean)
        .join(', ');
    },
    ariaLabel() {
      const contagem = this.total === 1 ? '1 reação' : `${this.total} reações`;
      return this.reactorNames ? `${contagem}: ${this.reactorNames}` : contagem;
    },
  },
};
</script>

<template>
  <div v-if="total" class="aceleres-reactions flex">
    <button
      type="button"
      :title="reactorNames"
      :aria-label="ariaLabel"
      class="aceleres-reaction-pill inline-flex h-7 items-center gap-[3px] rounded-full border border-n-weak bg-n-surface-1 px-[7px] text-xs text-n-slate-11 shadow-[0_2px_3px_-2px_rgba(0,0,0,0.24)] transition-colors hover:bg-n-surface-1 dark:shadow-none"
      @click.stop="$emit('open', $event.currentTarget)"
    >
      <EmojiGlyph
        v-for="emoji in visibleEmojis"
        :key="emoji"
        :emoji="emoji"
        size="reaction"
        class="relative !h-4 !w-4 !text-base leading-none"
      />
      <span v-if="total > 1" class="pl-[1px] leading-none">{{ total }}</span>
    </button>
  </div>
</template>
